"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stage = process.env.STAGE;
var previewToken;
var draftId;
exports.preset = {
    getDraftId: function () { return draftId; },
    getPreviewToken: function () { return previewToken; },
    getStage: function () { return stage; },
    setDraftId: function (id) {
        draftId = id;
    },
    setPreviewToken: function (token) {
        previewToken = token;
    },
    setStage: function (stageVar) {
        stage = stageVar;
    },
};
//# sourceMappingURL=preset.js.map